export default {
  storeId: 10000, //店铺ID
  UPLOAD_URL: process.env.API_HOST + "/common/uploadFile", //上传文件路径
  APK_UPLOAD_URL: process.env.API_HOST + "/manager/attachment/uploadApk", //apk上传文件路径
}












// WEBPACK FOOTER //
// ./src/constant/index.js